import { render, staticRenderFns } from "./historic_assigned_workers.vue?vue&type=template&id=f9ffcd12"
import script from "./historic_assigned_workers.vue?vue&type=script&lang=js"
export * from "./historic_assigned_workers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports